import { Select } from "../design/select";
import { useUser } from "../contexts/UserContext";
import { User } from "../models/User";

interface Props {
  value?: User["_id"];
  disabled?: boolean;
  onChange?: (user: User["_id"]) => void;
}

const SelectClient: React.FC<Props> = ({ disabled, value, onChange }) => {
  const { users } = useUser();

  const filteredUsers = users.filter((user) => user.role === "user");

  return (
    <Select
      value={value}
      onChange={(e) => onChange && onChange(e.target.value as User["_id"])}
      disabled={disabled}
    >
      <option value="">Select Client</option>
      {filteredUsers.map((user) => (
        <option key={user._id} value={user._id}>
          {user.name}
        </option>
      ))}
    </Select>
  );
};

export default SelectClient;
